import {addMilliseconds, format} from "date-fns";
import React, {memo} from "react";
import {getCurrencyIcon} from "app/utils/help";

import Countdown from "react-countdown";
import {IVipReloadProps} from "./types";
import {
    Badge,
    Box,
    ClaimsItem,
    Left,
    Line,
    NextClaim,
    Reloads,
    ReloadsClaims,
    ReloadsItem,
    ReloadsItems,
    ReloadsTitle,
    Right,
    StyledCryptoValue,
} from "./styles";
import {GradientButton, GradientWrapper, TitleWithCurrency} from "@housebets/housebets-x-package";
import {useIntl} from "react-intl";

const VipReload: React.FC<IVipReloadProps> = ({isLoading, title, total, onClick, claims, className, style, ...props}) => {
    const {$t} = useIntl();

    return (
        <Box className={className} style={style} {...props} key={claims.bonusId}>
            {claims.list?.length === 1 ? (
                <Reloads>
                    <Line>
                        <ReloadsTitle>{$t({id: "VipReload.info.single"})}</ReloadsTitle>
                    </Line>
                </Reloads>
            ) : claims.list?.length ? (
                <Reloads>
                    <Line>
                        <ReloadsTitle>{$t({id: "VipReload.info.multi"}, {maxLevels: claims.maxLevels})}</ReloadsTitle>
                        <ReloadsItems>
                            {claims.list?.map((item, i) => (
                                <ReloadsItem key={i} $fill={item.status === 2} $missed={item.status === 3} $ready={item.status === 1 && item.leftTime === 0} />
                            ))}
                        </ReloadsItems>
                    </Line>
                    <ReloadsClaims>
                        {claims.list?.map((item, i, list) => {
                            const isAvailable = item.status === 1 && item.leftTime === 0;

                            return (
                                <ClaimsItem
                                    key={i}
                                    $position={item.level}
                                    $max={claims.maxLevels}
                                    $current={claims.currentLevel}
                                    $available={isAvailable}
                                    $claimed={item.status === 2}
                                    $positionInViewport={item.level - claims.currentLevel}
                                    className={`item position-${item.level - claims.currentLevel}`}
                                    style={{
                                        "--position-in-viewport": item.level - claims.currentLevel,
                                    }}>
                                    <Left>
                                        {$t({id: "VipReload.reload"}, {level: item.level})}{" "}
                                        {isAvailable ? (
                                            <Badge>{$t({id: "VipReload.available"})}</Badge>
                                        ) : item.leftTime > 0 && item.level === claims.currentLevel ? (
                                            <NextClaim>
                                                {$t({id: "VipReload.claimIn"})}{" "}
                                                <Countdown
                                                    key={item.level}
                                                    date={format(addMilliseconds(new Date(), item.leftTime), "yyyy-MM-dd HH:mm:ss")}
                                                    renderer={({days, hours, minutes, seconds}) => (
                                                        <div>
                                                            {days ? days * 24 + hours : hours}h : {minutes}m : {seconds}s
                                                        </div>
                                                    )}
                                                />
                                            </NextClaim>
                                        ) : null}{" "}
                                    </Left>
                                    <Right>
                                        <StyledCryptoValue
                                            v2
                                            amount={item.amount}
                                            currencyImg={getCurrencyIcon(total.currency)}
                                            currency={total.currency.toString()}
                                        />
                                    </Right>
                                </ClaimsItem>
                            );
                        })}
                    </ReloadsClaims>
                </Reloads>
            ) : null}

            <GradientWrapper>
                <TitleWithCurrency amount={total.amount} icon={getCurrencyIcon(total.currency)} title={$t({id: "VipReload.totalReward"})} />
            </GradientWrapper>
            <GradientButton
                kind="fill"
                text={$t({id: "VipReload.claim"})}
                fullWidth
                disabled={
                    claims.list.find((v) => v.level === claims.currentLevel)?.status !== 1 ||
                    claims.list.find((v) => v.level === claims.currentLevel)?.leftTime !== 0
                }
                isLoading={isLoading}
                onClick={onClick}
                size="md-2"
            />
        </Box>
    );
};
export default memo(VipReload);
